/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserImportRowResult } from './UserImportRowResult';
import {
    UserImportRowResultFromJSON,
    UserImportRowResultFromJSONTyped,
    UserImportRowResultToJSON,
    UserImportRowResultToJSONTyped,
} from './UserImportRowResult';

/**
 * Per-row results and counts of a bulk import.
 * @export
 * @interface UserImportResponse
 */
export interface UserImportResponse {
    /**
     * 
     * @type {Array<UserImportRowResult>}
     * @memberof UserImportResponse
     */
    results: Array<UserImportRowResult>;
    /**
     * 
     * @type {number}
     * @memberof UserImportResponse
     */
    created_count: number;
    /**
     * 
     * @type {number}
     * @memberof UserImportResponse
     */
    skipped_count: number;
}

/**
 * Check if a given object implements the UserImportResponse interface.
 */
export function instanceOfUserImportResponse(value: object): value is UserImportResponse {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('created_count' in value) || value['created_count'] === undefined) return false;
    if (!('skipped_count' in value) || value['skipped_count'] === undefined) return false;
    return true;
}

export function UserImportResponseFromJSON(json: any): UserImportResponse {
    return UserImportResponseFromJSONTyped(json, false);
}

export function UserImportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserImportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(UserImportRowResultFromJSON)),
        'created_count': json['created_count'],
        'skipped_count': json['skipped_count'],
    };
}

export function UserImportResponseToJSON(json: any): UserImportResponse {
    return UserImportResponseToJSONTyped(json, false);
}

export function UserImportResponseToJSONTyped(value?: UserImportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': ((value['results'] as Array<any>).map(UserImportRowResultToJSON)),
        'created_count': value['created_count'],
        'skipped_count': value['skipped_count'],
    };
}

